// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3dpLQEeix{width:100%;max-width:360px;align-items:stretch;margin:0 auto}._5P2LYwYcx{height:40px}._3dke9Fn4x{font-weight:normal;margin:0;font-size:18px;color:#303030}\n", "",{"version":3,"sources":["webpack://client/login/update-username.scss"],"names":[],"mappings":"AAAwmB,YAAO,UAAU,CAAC,eAAe,CAAC,mBAAmB,CAAC,aAAa,CAAC,YAAM,WAAW,CAAC,YAAO,kBAAkB,CAAC,QAAQ,CAAC,cAAc,CAAC,aAAa","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.shell{width:100%;max-width:360px;align-items:stretch;margin:0 auto}.logo{height:40px}.title{font-weight:normal;margin:0;font-size:18px;color:#303030}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"shell": "_3dpLQEeix",
	"logo": "_5P2LYwYcx",
	"title": "_3dke9Fn4x"
};
export default ___CSS_LOADER_EXPORT___;
